import React from 'react'
import styled from 'styled-components'
import { useParams } from 'react-router-dom'
import ActionButton, { ActionButtonA } from 'uiComponents/buttons'
import { BaseRouteParams } from '../../../../hocs'
import OverlayConfig from './overlayConfig'
import useUpdateMap from 'venue/parkMap/hooks/useUpdateMap'
import SnapshotConfig from './snapshotConfig'
import { useSelectedParkMapContext } from 'venue/parkMap/context/selectedParkMap'
import OverlayBackgroundColorSelector from './backgroundColorSelector'
import InformationBox from '../informationBox'
import { useTranslation } from 'translations'

export const TabContainer = styled.div`
    display: flex;
    flex: 1;
    justify-content: space-between;
    padding-top: 1em;
`

const Form = styled.form`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`

const Content = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
`

export const Footer = styled.div`
    display: flex;
    justify-content: space-between;
    border-top-width: 1px;
    border-top-style: solid;
    border-top-color: ${(props) => props.theme.colors.border};
    padding-top: 1em;
`

const Config = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 10px;
`

const Info = styled.div`
    margin: 0.5em 0 1.5em 0;
`

const StyleDetails = () => {
    const { t } = useTranslation()
    const { accountSlug } = useParams<BaseRouteParams>()
    const { updateMapStylingData } = useUpdateMap()
    const { selectedParkMap, setSelectedParkMap } = useSelectedParkMapContext()

    const saveChanges = () => {
        updateMapStylingData()
    }

    return (
        <Form>
            <Content>
                <Config>
                    <Info>
                        <InformationBox text={t('venue.parkMap.mapStyle.info')} />
                    </Info>
                    <OverlayBackgroundColorSelector
                        onColorChange={(bgColor) => {
                            setSelectedParkMap((prev) => {
                                if (prev && prev.overlay) {
                                    return {
                                        ...prev,
                                        overlay: {
                                            ...prev.overlay,
                                            bgColor: bgColor,
                                        },
                                    }
                                }
                                return prev
                            })
                        }}
                        bgColor={selectedParkMap?.overlay?.bgColor ?? null}
                    />
                    <SnapshotConfig />
                    <OverlayConfig />
                </Config>
            </Content>
            <Footer>
                <ActionButtonA size="large" href={`/account/${accountSlug}/venue/park_map/list`} secondary>
                    {t('venue.parkMap.mapDetails.backToList')}
                </ActionButtonA>
                <ActionButton size="large" onClickCapture={saveChanges}>
                    {t('common.save')}
                </ActionButton>
            </Footer>
        </Form>
    )
}

export default StyleDetails
